/** Enforcing theme tokens to be used for volkswagen */
const themeTokens = {
    primaryColor: '#0E3A2F',
    hoveredPrimaryColor: '#69b54e',
    textColor: '#fff',

    baseFontSize: '0.75rem',
    buttonFontSize: '0.75rem',
    inputFontSize: '1rem',
};

export default themeTokens;
